(function () {
  'use strict';

  angular
      .module('tfc.retailer.Returns', [])
      .config(config)
      .constant('PageSize', 100);

  // @ngInject
  function config($stateProvider) {

    $stateProvider
        .state('returns', {
          abstract : true,
          parent : 'pageWithMenu',
          url : '/returns',
          data : {
            auth : { privilege : 'report.BrandReturnsPerformance' },
            requireTerms:true
          },
          template : '<ui-view></ui-view>'
        })
        .state('returns.Performance', {
          url : '/Performance?brandKey&hierarchy&department&category&{pageNumber:int}&{pageSize:int}&transaction&region&sortBy&sortOrder',
          params : {
            pageNumber : 1,
            pageSize : 100 // default page size
          },
          data:{
            title:'Returns Benchmark',
            path:'returns/Performance'
          },
          templateUrl : 'Returns/ReturnsPerformance.tmpl.html',
          controller : 'ReturnsPerformanceCtrl as vm',
          resolve : {
            selectedBrandKey: function(BrandReports, $stateParams){
              return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                $stateParams.brandKey = selectedBrandKey;
                return selectedBrandKey;
              });
            },
            filters: function (BrandReports, $stateParams, activityRegion, selectedBrandKey) {
                return activityRegion( function() {
                  return BrandReports.getReturnsPerformanceFilters(selectedBrandKey)
                },$stateParams.transaction, $stateParams.region);
            },
            summary : function (filters, BrandReports, $stateParams, selectedBrandKey) {
                var transaction = filters.getSelected();
                var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                if(!$stateParams.hierarchy) {
                  $stateParams.hierarchy = "All Categories";
                }
                return BrandReports.getReturnsPerformanceSummary(selectedBrandKey, transaction && transaction.getLabel(), region);
            },
            styleData : function (BrandReports, $stateParams, filters, selectedBrandKey) {
                if($stateParams.hierarchy) {
                  var transaction = filters.getSelected();
                  var region = transaction && transaction.getSelectedRegion() && transaction.getSelectedRegion().getLabel();
                  return BrandReports.getReturnsPerformance(selectedBrandKey, $stateParams.department, $stateParams.category, transaction && transaction.getLabel(), region);
                }
            },
            brands : function (BrandReports) {
              return BrandReports.findUserBrandNames();
            },
            aggregationLogDetails : function(BrandReports) {
              return BrandReports.getDashboardAggregationLogDetails('ReturnsPerformance');
            }
          }
        })
        .state('returns.PerformanceBySize', {
          url : '/Performance/returnsBySize?brandKey&hierarchy&department&category&sizeType&localeCode&{pageNumber:int}&{pageSize:int}',
          params : {
            pageNumber : 1,
            pageSize : 100 // default page size
          },
          data : {
            auth : { privilege : 'report.BrandReturnsPerformanceBySize' },
            requireTerms:true,
            title:'Returns Benchmark By Size',
            path:'returns/PerformanceBySize'
          },
          templateUrl: 'ReturnsBySize/ReturnsPerformanceBySize.tmpl.html',
          controller : 'ReturnsPerformanceBySizeCtrl as vm',
          resolve : {
            selectedBrandKey: function(BrandReports, $stateParams){
              return BrandReports.selectedBrandKey($stateParams.brandKey).then(function(selectedBrandKey){
                $stateParams.brandKey = selectedBrandKey;
                return selectedBrandKey;
              });
            },
            hierarchies : function (BrandReports, $stateParams, selectedBrandKey) {
                return BrandReports.getReturnsPerformanceBySizeHierarchies(selectedBrandKey);
            },
            summary: function (BrandReports, $stateParams,hierarchies, selectedBrandKey) {
              if(hierarchies && hierarchies.length) {
                  $stateParams.brandKey = selectedBrandKey;
                  $stateParams.department = $stateParams.department || (hierarchies[0] && hierarchies[0].department);
                  $stateParams.category = $stateParams.category || (hierarchies[0] && hierarchies[0].category);
                  $stateParams.sizeType = $stateParams.sizeType || (hierarchies[0] && hierarchies[0].sizeType);
                  $stateParams.localeCode = $stateParams.localeCode || (hierarchies[0] && hierarchies[0].localeCode);
                  return BrandReports.getReturnsPerformanceBySizeSummary(selectedBrandKey, $stateParams.department,
                      $stateParams.category, $stateParams.localeCode, $stateParams.sizeType);
              }
            },
            brands : function (BrandReports) {
              return BrandReports.findUserBrandNames();
            },
            aggregationLogDetails : function(BrandReports) {
              return BrandReports.getDashboardAggregationLogDetails('ReturnPerformanceBySize');
            }
          }
        })
  }

})();